var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Pagination'),_vm._l((_vm.results),function(result){return _c('Result',{key:result._id,attrs:{"result":result,"query":_vm.query}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }